import React, { useEffect, useState } from "react";

export default function ActorHeroBackdrop({
    movie,
    isQuebecProduction = false,
    onBackdropReady,
}) {
    const [images, setImages] = useState({
        current: null,
        previous: null,
        currentMovie: null,
    });
    const path = movie?.backdrop_path;

    useEffect(() => {
        // Une affiche verticale ne remplace pas un fond panoramique absent.
        if (!path) return undefined;

        // Détection de la taille d'écran pour optimiser TMDB
        const isMobile = window.innerWidth <= 900;
        const sizeString = isMobile ? "w780" : "w1280";
        const url = `https://image.tmdb.org/t/p/${sizeString}${path}`;
        // const url = `https://image.tmdb.org/t/p/w1280${path}`;
        const image = new Image();
        let cancelled = false;

        image.onload = () => {
            if (cancelled) return;

            setImages((old) => {
                const sameImage =
                    old.current === url;

                const sameMovie =
                    Number(old.currentMovie?.id) ===
                    Number(movie?.id);

                if (sameImage && sameMovie) {
                    return old;
                }

                return {
                    current: url,
                    previous: old.current,
                    currentMovie: movie,
                };
            });
        };
        // Une erreur conserve le dernier fond chargé correctement.
        image.onerror = () => { };
        image.src = url;

        return () => {
            cancelled = true;
            image.onload = null;
            image.onerror = null;
        };
    }, [path]);

    useEffect(() => {
        if (
            !images.current ||
            !images.currentMovie?.id
        ) {
            return;
        }

        onBackdropReady?.(
            images.currentMovie
        );
    }, [
        images.current,
        images.currentMovie,
        onBackdropReady,
    ]);

    if (!images.current) return null;

    return (
        <>
            <div
                className="actor-hero-backdrop"
                data-quebec-production={
                    isQuebecProduction ? "true" : undefined
                }
                aria-hidden="true"
            >
                <div className="actor-hero-backdrop__shape">
                    {images.previous && (
                        <div
                            className="actor-hero-backdrop__image"
                            style={{ backgroundImage: `url("${images.previous}")` }}
                        />
                    )}
                    <div
                        key={images.current}
                        className="actor-hero-backdrop__image actor-hero-backdrop__image--incoming"
                        style={{ backgroundImage: `url("${images.current}")` }}
                    />
                    <div className="actor-hero-backdrop__veil" />
                </div>
            </div>
        </>
    );
}